import { Bold } from '@tiptap/extension-bold';
import { BulletList } from '@tiptap/extension-bullet-list';
import { Document } from '@tiptap/extension-document';
import { HardBreak } from '@tiptap/extension-hard-break';
import { History } from '@tiptap/extension-history';
import { Italic } from '@tiptap/extension-italic';
import { ListItem } from '@tiptap/extension-list-item';
import { OrderedList } from '@tiptap/extension-ordered-list';
import { Paragraph } from '@tiptap/extension-paragraph';
import { Placeholder } from '@tiptap/extension-placeholder';
import { Text } from '@tiptap/extension-text';
import { Underline } from '@tiptap/extension-underline';
import {
  MenuButtonBold,
  MenuButtonBulletedList,
  MenuButtonItalic,
  MenuButtonOrderedList,
  MenuButtonUnderline,
  MenuControlsContainer,
  MenuDivider,
  RichTextEditor,
} from 'mui-tiptap';

const extensions = [
  Document,
  Paragraph,
  Text,
  Bold,
  Italic,
  Underline,
  BulletList,
  OrderedList,
  ListItem,
  HardBreak,
  History,
  Placeholder.configure({ placeholder: "Describe this dashboard's process for the Home page…" }),
];

interface MyViewDashboardDescriptionEditorProps {
  initialContent: string;
  onChange: (description: string) => void;
}

export function MyViewDashboardDescriptionEditor({ initialContent, onChange }: MyViewDashboardDescriptionEditorProps) {
  return (
    <RichTextEditor
      extensions={extensions}
      content={initialContent}
      // A cleared editor still holds an empty paragraph, so report it as no description.
      onUpdate={({ editor }) => onChange(editor.isEmpty ? '' : editor.getHTML())}
      renderControls={() => (
        <MenuControlsContainer>
          <MenuButtonBold />
          <MenuButtonItalic />
          <MenuButtonUnderline />
          <MenuDivider />
          <MenuButtonBulletedList />
          <MenuButtonOrderedList />
        </MenuControlsContainer>
      )}
      RichTextFieldProps={{ variant: 'outlined' }}
      sx={{ '& .ProseMirror': { minHeight: 96 } }}
    />
  );
}
